import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'lib-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['../../forms.component.scss'],
})
export class PreviewComponent {
  constructor(
    public dialogRef: MatDialogRef<PreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}
}
